export default {
	currentComponentsInBuild (state) {
		let configBuild = {};
		state.configComponentList.forEach(component => {
			if (component.id) {
				configBuild = {
					...configBuild,
					[component.groupId]: component.id,
				};
			}
		});

		// This looks silly goofy but it is imperative to preserve key order
		return JSON.parse(JSON.stringify(configBuild));
	},
	configCartObject (state, getters) {
		return {
			...state.mainProduct,
			categoryTree: 'Datorer & Tillbehör/Stationär dator/Webhallen Config/Custom',
			brand: 'Webhallen',
			config: {
				components: getters.currentComponentsInBuild,
				assemblyTime: [state.mainProduct?.assemblyTime?.from, state.mainProduct?.assemblyTime?.to],
				...Object.keys(state.exchanges).length && {exchanges: state.exchanges}
			}
		};
	},
};